import { getProtocolTypeColor, getProtocolTypeTranslationKey } from "@msuite/utils/protocols";
import type { Tables } from "@msuite/utils/types";
import { localized } from "../localization";
import { Tag, type TagProps } from "./tag";

/** Props Interface */
interface ProtocolTypeTagProps extends TagProps {
	type: Tables<"protocols">["type"];
}

export function ProtocolTypeTag({ type, color, ...props }: ProtocolTypeTagProps) {
	return (
		<Tag
			color={color || getProtocolTypeColor(type)}
			{...props}
		>
			{localized(getProtocolTypeTranslationKey(type))}
		</Tag>
	);
}
